/*=============================================== LangSelect styles ===============================================*/

import styled from "styled-components/macro"
import {
    Radiuses,
    Mixins,
    FontWeights,
    FontSizes,
    Breakpoints,
    Transitions,
    Spacers,
    Shadows,
} from "tsx-library-julseb"

export const StyledLangSelect = styled.div`
    position: relative;

    button {
        border: none;
        text-align: left;
    }
`

const BUTTON_WIDTH = 48

export const Button = styled.button`
    color: ${({ theme }) => theme.ColorsHoverDefault({ $color: "white" })};
    background-color: transparent;
    border-radius: ${Radiuses.S};
    height: 32px;
    width: ${BUTTON_WIDTH}px;
    padding: 0;
    font-weight: ${FontWeights.Regular};
    font-size: ${FontSizes.Body};
    transition: ${Transitions.Short};
    ${Mixins.Flexbox({
        $inline: true,
        $alignItems: "center",
        $gap: "xs",
    })}

    @media ${Breakpoints.Hover} {
        &:hover {
            color: ${({ theme }) =>
                theme.ColorsHoverHover({ $color: "white" })};
        }

        &:active {
            color: ${({ theme }) =>
                theme.ColorsHoverActive({ $color: "white" })};
        }
    }

    &[data-theme="dark"] {
        color: ${({ theme }) =>
            theme.ColorsHoverDefault({ $color: "primary" })};

        @media ${Breakpoints.Hover} {
            &:hover {
                color: ${({ theme }) =>
                    theme.ColorsHoverHover({ $color: "primary" })};
            }

            &:active {
                color: ${({ theme }) =>
                    theme.ColorsHoverActive({ $color: "primary" })};
            }
        }
    }
`

export const List = styled.div`
    position: absolute;
    left: 0;
    width: ${BUTTON_WIDTH}px;
    border-radius: ${Radiuses.S};
    overflow: hidden;
    box-shadow: ${Shadows.XS};
    max-height: 0;
    transition: ${Transitions.Short};

    &.open {
        max-height: 200px;
    }
`

export const Item = styled.button`
    width: 100%;
    background-color: ${({ theme }) => theme.Background};
    padding: ${Spacers.XXS} ${Spacers.XS};
    transition: ${Transitions.Short};
    color: ${({ theme }) => theme.Font};

    &.active {
        background-color: ${({ theme }) =>
            theme.ColorsHoverDefault({ $color: "primary" })};
        color: ${({ theme }) => theme.Background};
    }

    @media ${Breakpoints.Hover} {
        &:hover {
            background-color: ${({ theme }) =>
                theme.ColorsHoverHover({ $color: "primary" })};
            color: ${({ theme }) => theme.Background};
        }

        &:active {
            background-color: ${({ theme }) =>
                theme.ColorsHoverActive({ $color: "primary" })};
        }
    }
`
